import React, { useEffect, useState } from 'react';
import { Card, CardBody, Container, Row, Col, Button, Spinner } from 'reactstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import config from '../../config';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BreadCrumb from '../../Components/Common/BreadCrumb';

// Add custom styles
const editorStyle = `
.quill-editor .ql-container.ql-snow {
    height: 90% !important;
    overflow-y: auto;
}

/* Add Merriweather font styles */
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Merriweather"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Merriweather"]::before {
    content: 'Merriweather';
    font-family: 'Merriweather', serif;
}

.ql-font-Merriweather {
    font-family: 'Merriweather', serif;
}
`;

const PrivacyPolicy = () => {
    document.title = "Privacy Policy";
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPrivacyPolicy = async () => {
            try {
                setLoading(true);
                const authUser = JSON.parse(sessionStorage.getItem("authUser"));
                const response = await fetch(`${config.api.API_URL}htmlPage?type=1&lan=en`, {
                    headers: {
                        'Authorization': authUser.token
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch privacy policy');
                }

                const data = await response.json();
                if (data.message === "Success") {
                    setContent(data.data.pageContent);
                } else {
                    throw new Error(data.message || 'Failed to fetch privacy policy');
                }
            } catch (err) {
                console.error('Error fetching privacy policy:', err);
                setError('Failed to load privacy policy content');
                toast.error(err.message || 'Failed to load privacy policy', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "colored"
                    });
            } finally {
                setLoading(false);
            }
        };

        fetchPrivacyPolicy();
    }, []);

    const handleSave = async () => {
        try {
            setSaving(true);
            const authUser = JSON.parse(sessionStorage.getItem("authUser"));
            const response = await fetch(`${config.api.API_URL}htmlPage`, {
                method: 'POST',
                headers: {
                    'Authorization': authUser.token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    type: 1,
                    lan: 'en',
                    pageContent: content
                })
            });

            if (!response.ok) {
                throw new Error('Failed to update privacy policy');
            }

            toast.success('Privacy policy updated successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                theme: "colored"
            });
        } catch (err) {
            console.error('Error saving privacy policy:', err);
            toast.error(err.message || 'Failed to update privacy policy', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "colored"
                });
            } finally {
            setSaving(false);
        }
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'font': ['', 'Merriweather', 'Arial', 'Times New Roman'] }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'align': [] }],
            ['blockquote', 'code-block'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link', 'image'],
            ['clean']
        ],
    };

    return (
        <>
        <div className="page-content">
                <style>{editorStyle}</style>
            <Container fluid>
                    <BreadCrumb title="Privacy Policy" pageTitle="Settings" />
                <Row>
                        <Col xs={12}>
                        <Card>
                                            <CardBody>
                                    {loading ? (
                                        <div className="text-center">Loading...</div>
                                    ) : error ? (
                                        <div className="text-danger">{error}</div>
                                    ) : (
                                        <>
                                            <div style={{ height: '85vh' }}>
                                                <ReactQuill
                                                    theme="snow"
                                                    value={content}
                                                    onChange={setContent}
                                                    modules={modules}
                                                    className="quill-editor"
                                                    style={{ height: '85vh' }}
                                                                    />
                                                                </div>
                                            <div className="text-end mt-3">
                                                        <Button
                                                            color="primary"
                                                    onClick={handleSave}
                                                    disabled={saving}
                                                >
                                                    {saving ? <><Spinner size="sm" className="me-2" />Saving...</> : 'Save Changes'}
                                                        </Button>
                                                                            </div>
                                        </>
                                    )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </>
    );
};

export default PrivacyPolicy;